import React from 'react';
import CocktailDashboard from './components/complete-tasting-dashboard';

function App() {
  return <CocktailDashboard />;
}

export default App;
